import { InjectionToken } from '@angular/core';

import { ConstantsLoader } from './constants-loader.service';

export const CONSTANTS_LOADER = new InjectionToken<ConstantsLoader>(
  'CONSTANTS_LOADER'
);
